import {downgradeComponent} from '@angular/upgrade/static';
import {barnManagerModule} from '../../index.module';
import {ProductSelectComponent} from '../../../app/feed/product-select/product-select.component';

barnManagerModule.directive('ng2ProductSelect', downgradeComponent({ component: ProductSelectComponent }));
